import CardView from './ActiveMessageTemplateCardView.html';
import './ActiveMessageTemplateCard.scss';
import { validateImageUrl } from '../../../../../shared/helpers/Image';
import { validateVideoUrl } from '../../../../../shared/helpers/Video';
import { CallToActionTypes } from '../../../contents/messageTemplates/models/MessageTemplateButtons';
import { MessageTemplateContentTypes } from 'modules/application/detail/contents/messageTemplates/createMessageTemplateSidebar/CreateMessageTemplateSidebarController';
import { MessageTemplateDeafaultImageConstants } from '../../../DetailConstants';
import { isNullOrWhiteSpace } from 'data/string';
class ActiveMessageTemplateCardController {
    static $inject = ['$element', 'MessageTemplateUtil', '$scope'];
    constructor($element, MessageTemplateUtil, $scope) {
        'ngInject';
        this.optionsAction = [];
        this.optionsButtons = [];
        this.$element = $element;
        this.MessageTemplateUtil = MessageTemplateUtil;
        this.$scope = $scope;
        this.$scope = {
            ...this.$scope,
            previewMode: false,
            inputValue: '',
            footerValue: '',
            selectedText: {
                finalText: '',
                initialText: '',
                textSelected: '',
            },
        };
        this.$onInit();
    }
    setAdaptedMessageTemplate(value) {
        if (isNullOrWhiteSpace(value)) {
            return;
        }
        const list = this.getPreviewElement();
        list.forEach((element) => {
            const elementHtml = element;
            if (elementHtml['classList'] && elementHtml['classList'].contains('amtc__description')) {
                elementHtml['innerHTML'] = this.MessageTemplateUtil.formatMessageToPreviewView(value);
            }
        });
    }
    setAdaptedHeaderTemplate(value) {
        if (isNullOrWhiteSpace(value)) {
            return;
        }
        const element = this.$element[0];
        const headerList = element.querySelectorAll('.amtc__header');
        headerList.forEach((element) => {
            const elementHtml = element;
            elementHtml['innerHTML'] = this.MessageTemplateUtil.formatMessageToPreviewView(value);
        });
    }
    getPreviewElement() {
        const element = this.$element[0];
        return element.querySelectorAll('.amtc__description, .amtc__header');
    }
    async $onChanges() {
        this.isVideoValid = false;
        this.isImageValid = false;
        this.defaultImage = ' ';
        switch (this.type) {
            case MessageTemplateContentTypes.IMAGE:
                if (this.preview) {
                    await this.validateImage();
                }
                this.defaultImage = MessageTemplateDeafaultImageConstants.MESSAGE_TEMPLATE_DEFAULT_IMAGE_URL;
                this.image = this.preview;
                this.video = undefined;
                this.document = undefined;
                break;
            case MessageTemplateContentTypes.VIDEO:
                if (this.preview) {
                    await this.validateVideo();
                }
                this.defaultImage = MessageTemplateDeafaultImageConstants.MESSAGE_TEMPLATE_DEFAULT_VIDEO_IMAGE_URL;
                this.video = this.preview;
                this.image = undefined;
                this.document = undefined;
                break;
            case MessageTemplateContentTypes.DOCUMENT:
                this.defaultImage = MessageTemplateDeafaultImageConstants.MESSAGE_TEMPLATE_DEFAULT_DOCUMENT_IMAGE_URL;
                this.document = this.preview;
                this.video = undefined;
                this.image = undefined;
                break;
        }
        this.hasButtons();
        this.setAdaptedMessageTemplate(this.description);
        this.setAdaptedHeaderTemplate(this.headerText);
    }
    async $onInit() {
        switch (this.type) {
            case 'image':
                this.defaultImage = MessageTemplateDeafaultImageConstants.MESSAGE_TEMPLATE_DEFAULT_IMAGE_URL;
                break;
            case 'video':
                this.defaultImage = MessageTemplateDeafaultImageConstants.MESSAGE_TEMPLATE_DEFAULT_VIDEO_IMAGE_URL;
                break;
            case 'document':
                this.defaultImage = MessageTemplateDeafaultImageConstants.MESSAGE_TEMPLATE_DEFAULT_DOCUMENT_IMAGE_URL;
                break;
        }
        if (this.type === 'image' && this.preview) {
            await this.validateImage();
        }
        else if (this.type === 'video' && this.preview) {
            await this.validateVideo();
        }
        this.hasButtons();
        this.setAdaptedMessageTemplate(this.description);
        this.setAdaptedHeaderTemplate(this.headerText);
    }
    async validateImage(returnToDefault = false) {
        const replaceImage = returnToDefault
            ? MessageTemplateDeafaultImageConstants.MESSAGE_TEMPLATE_DEFAULT_IMAGE_URL
            : MessageTemplateDeafaultImageConstants.MESSAGE_TEMPLATE_IMAGE_INVALID_URL;
        validateImageUrl(this.preview).then(() => (this.isImageValid = true), () => ((this.isImageValid = false), (this.defaultImage = replaceImage)));
    }
    async validateVideo(returnToDefault = false) {
        this.isVideoValid = true;
        const replaceImage = returnToDefault
            ? MessageTemplateDeafaultImageConstants.MESSAGE_TEMPLATE_DEFAULT_VIDEO_IMAGE_URL
            : MessageTemplateDeafaultImageConstants.MESSAGE_TEMPLATE_VIDEO_INVALID_URL;
        validateVideoUrl(this.preview).then(() => undefined, () => ((this.isVideoValid = false), (this.defaultImage = replaceImage)));
    }
    hasButtons() {
        this.optionsAction = [];
        this.optionsButtons = [];
        if (this.templateButtons) {
            const options = JSON.parse(this.templateButtons);
            options.forEach((item) => {
                const lowerType = item.type.toLowerCase();
                if (lowerType == CallToActionTypes.PHONE_NUMBER) {
                    this.optionsAction.push({
                        type: item.type.toUpperCase(),
                        text: item.text,
                        phone_number: item.phone_number,
                    });
                }
                else if (lowerType == CallToActionTypes.URL) {
                    this.optionsAction.push({
                        type: item.type.toUpperCase(),
                        text: item.text,
                        url: item.url,
                    });
                }
                else {
                    this.optionsButtons.push({
                        type: item.type.toUpperCase(),
                        text: item.text,
                    });
                }
            });
        }
    }
}
ActiveMessageTemplateCardController.$inject = ['$element', 'MessageTemplateUtil', '$scope'];
export const ActiveMessageTemplateCardComponent = {
    template: CardView,
    controller: ActiveMessageTemplateCardController,
    controllerAs: '$ctrl',
    bindings: {
        preview: '@?',
        templateButtons: '@?',
        onConfirm: '&?',
        type: '@',
        image: '=?',
        document: '=?',
        video: '=?',
        isTranslation: '&?',
        isImageValid: '=?',
        isVideoValid: '=?',
        onlyPreview: '=?',
        useFormattedHtml: '=?',
        description: '@?',
        subtitle: '@?',
        footer: '@?',
        headerText: '@?',
        buttonType: '=?',
        options: '=?',
        thereTranslations: '&?',
    },
};
